module.exports = __webpack_public_path__ + "static/media/124.3dc12264.webp";